

export class ApiPort {
  port: number;
  sslPort: number;
  ssl: boolean;
  constructor() {
    this.port = 9098;
    this.sslPort = 8098;
    this.ssl = false;
  }
  init(url: string,newPort:number,diff:number=1000):string {
    const portStart = url.indexOf(':',8)+1;
    const portStr = url.substring(portStart,portStart+4);
    if (url.startsWith('https://')) {
      this.ssl = true;
      this.sslPort = newPort; // Number(portStr);
      this.port = this.sslPort + diff;
      const newUrl = url.replace(':'+portStr,':'+this.sslPort.toString());
      return newUrl;
    } else {
      this.sslPort = newPort; // this.port - diff;
      this.port = newPort+diff;//Number(url.substring(portStart, portStart+4));
      const newUrl = url.replace(':'+portStr,':'+this.port.toString());
      return newUrl;
    }
  }
  getPort(): number {
    if(this.ssl)
      return this.sslPort;
    else
    return this.port;
  }
}
